import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Supplier_Reports } from "../../db_access/supplier_reports";

const InvitationReport = ({ report, setRefresh, showAction = true }) => {
  const { t } = useTranslation();
  const typographyCommon = { fontFamily: "Poppins", fontWeight: 100 };
  const typographyLeft = { ...typographyCommon, textAlign: "left" };
  const typographyRight = { ...typographyCommon, textAlign: "right" };
  const fields = [
    { label: t("Name"), field: "name" },
    { label: t("Level"), field: "level" },
    { label: t("Scope"), field: "scope" },
    { label: t("Year"), field: "year" },
    { label: t("Quantity"), field: "quantity" },
    { label: t("Functional Unit"), field: "functional_unit" },
    { label: t("Other Unit"), field: "other_unit" },
    { label: t("GWP per unit"), field: "gwp_per_unit" },
    { label: t("GWP"), field: "gwp" },
    { label: t("Cost per unit"), field: "cost_per_unit" },
    { label: t("Cost"), field: "cost" },
    { label: t("Notes"), field: "notes" },
  ];
  return (
    <Box sx={{ display: "flex", paddingY: 1, paddingLeft: 2, paddingRight: 1 }}>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {fields
            .filter((f) => report?.[f.field] !== null)
            .map((f, i) => (
              <Box sx={{ minWidth: 200 }} key={i}>
                <Typography sx={typographyLeft}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Box sx={{ fontWeight: 500 }}>{f.label + ":"} </Box>
                    <Box>{report?.[f.field]}</Box>
                  </Box>
                </Typography>
              </Box>
            ))}
        </Box>
        <Box sx={{ gap: 2, display: "flex", mt: 2 }}>
          <Box sx={{ display: showAction && report.status === "Pending" ? "block" : "none" }}>
            <Button
              variant="contained"
              size="small"
              onClick={() => Supplier_Reports.accept(report.id).finally(() => setRefresh((r) => !r))}
              sx={{
                background: "#16a34a",
                "&:hover": { background: "#15803d" },
                fontFamily: "Poppins",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                px: 3
              }}
            >
              {t("Accept Report")}
            </Button>
          </Box>
          <Box sx={{ display: showAction && report.status === "Pending" ? "block" : "none" }}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => Supplier_Reports.reject(report.id).finally(() => setRefresh((r) => !r))}
              sx={{
                borderColor: "#dc2626",
                color: "#dc2626",
                "&:hover": { borderColor: "#b91c1c", background: "#fef2f2" },
                fontFamily: "Poppins",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "8px",
                px: 3
              }}
            >
              {t("Reject")}
            </Button>
          </Box>
          <Box
            sx={{
              display: !showAction || report.status !== "Pending" ? "block" : "none",
            }}>
            <Typography sx={{ ...typographyLeft, fontWeight: 700, color: report.status === "Accepted" ? "#16a34a" : "#dc2626", textTransform: "uppercase", fontSize: 12 }}>
              {t("Status")}: {t(report.status)}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography sx={typographyRight}>{t("Created at")}: {report.created_at.split(" GMT")[0]}</Typography>
        <Typography sx={typographyRight}>{t("Last Modified")}: {report.last_modified.split(" GMT")[0]}</Typography>
      </Box>
    </Box>
  );
};

export default InvitationReport;
